import { ContactComponent } from "../../components/contact"
import { DefaultTemplate } from "../../components/templates"

export const ContactPage = () => {
  return (
    <DefaultTemplate>
      <ContactComponent />
    </DefaultTemplate>
  )
}
